import React, { useState } from 'react'
import MonthView from './MonthView'
import WeekView from './WeekView'

const Calendar = () => {
  const [view, setView] = useState('month')
  
  
  return (
    <div className='mt-5'>
      {view === 'month' && <MonthView setView={setView}/>}
      {view === 'week' && <WeekView setView={setView}/>} 
    </div>
  )
}

export default Calendar